<div class="container">
  @if (user !== null) {
    <div class="main-wrapper">
      @if (userIsCurrentUser) {
        <div class="page-header-title" i18n>Your profile</div>
        <div class="page-sub-header" i18n>View and edit your personal information</div>
      } @else {
        <div class="page-header-title">{{ user.firstName }} {{ user.lastName }}</div>
        <div class="page-sub-header" i18n>View and edit personal information</div>
      }
      <div class="content-card-background">
        <header class="header-row">
          <h2 i18n>Personal information</h2>
          @if (
            currentUser !== null &&
            (
              userIsCurrentUser ||
              currentUser.role === RoleType.ADMIN ||
              currentUser.role === RoleType.SUPERADMIN
            )
          ) {
            <button class="skideo-flat-button white img-left" (click)="toEditUser()">
              <i class="fas fa-pencil button-icon"></i>
              <span i18n>Edit profile</span>
            </button>
          }
        </header>
        <div class="input-row">
          <div class="photo-label-wrapper">
            <label class="photo-label" i18n>Profile Photo</label>
          </div>
          <div class="image-upload">
            @if (user.photo === null) {
              <div class="no-user-photo"><i class="fal fa-user"></i></div>
            } @else {
              <img src="{{ user.photo }}" alt="profile-picture" />
            }
          </div>
        </div>
        <div class="input-row">
          <label i18n>First name</label>
          <p [class.spaced]="user.firstName === ''">{{ user.firstName }}</p>
        </div>
        <div class="input-row">
          <label i18n>Last name</label>
          <p [class.spaced]="user.lastName === ''">{{ user.lastName }}</p>
        </div>
        <div class="input-row">
          <label i18n>Position</label>
          <p [class.spaced]="user.function === ''">{{ user.function }}</p>
          <!--          *ngIf="user.function != ''"-->
        </div>
        <div class="input-row">
          <label i18n>E-mail</label>
          <p [class.spaced]="user.email === ''">{{ user.email }}</p>
        </div>
        <div class="input-row">
          <label i18n>Phone number</label>
          <p [class.spaced]="user.phone === ''">{{ user.phone }}</p>
        </div>
        <div class="input-row">
          <label i18n>Language</label>
          @switch (user.language) {
            @case (LanguageType.DUTCH) {
              <p i18n>Dutch</p>
            }
            @case (LanguageType.ENGLISH) {
              <p i18n>English</p>
            }
          }
        </div>
        <div class="input-row">
          <label i18n>Role</label>
          @switch (user.role) {
            @case (RoleType.USER) {
              <p i18n>User</p>
            }
            @case (RoleType.ADMIN) {
              <p i18n>Admin</p>
            }
            @case (RoleType.SUPERADMIN) {
              <p i18n>Super admin</p>
            }
          }
        </div>
        @if (
          currentUser !== null && currentUser.role === RoleType.ADMIN 
          || currentUser !== null && currentUser.role === RoleType.SUPERADMIN
        ) {
          <div class="input-row top">
            <label i18n>Labels</label>
            <div class="labels-container">
              @if (user.role === RoleType.USER) {
                @for (e of user.labels.edges; track e) {
                  <label class="user-label">
                    {{e.node.name}}
                  </label>
                }
              }
              @if (user.role === RoleType.SUPERADMIN || user.role === RoleType.ADMIN) {
                <label class="user-label" i18n>All labels</label>
              }
            </div>
          </div>
        }
        <div class="footer-row">
          <button (click)="navigateBack()" class="skideo-flat-button white img-left">
            <img src="assets/icons/arrow-left.svg" alt="" />
            <span i18n>Previous</span>
          </button>
        </div>
      </div>
    </div>
  }
</div>
